import { request } from "../request";
import { isHXApp } from "@saas/components/src";
//获取课时切片信息
export const getLessonOutline = (params) =>
  request(`/v1/userCourse/getLessonOutline`, "get", { params });

export const getCourseList = (params) =>
  request(`/v1/userCourse/getCourseList`, "get", { params });

export const getCourseDetail = (params) =>
  request(`/v1/userCourse/getCourseDetail`, "get", {
    params: {
      answer_type: isHXApp() ? 1 : 0,
      ...params,
    },
  });
export const getCalendarCourseList = (params) =>
  request(`/v1/userCourse/getCalendarCourseList`, "get", {
    params,
  });
export const getLessonDetail = (params) =>
  request(`/v1/userCourse/getLessonDetail`, "get", {
    params,
  });
export const playbackKeepAlive = (params) =>
  request(`/v1/userCourse/playbackKeepALive`, "post", {
    json: params,
  });

// 获取看课记录
export const getLookList = (params) =>
  request(`/v1/userCourse/getCourseProgress`, "get", {
    params,
  });
// 获取订单列表
export const getOrderList = (params) =>
  request(`/v1/order/list`, "get", {
    params,
  });
// 获取退款列表
export const getRefundList = (params) =>
  request(`/v1/order/refund/list_v2`, "get", {
    params,
  });
export const applyRefund = (params) =>
  request(`/v1/order/refund/apply_v2`, "post", {
    json: params,
  });
// 拼团-退款
export const groupOrderRefund = (params) =>
  request(`/v1/order/refund`, "post", {
    json: params,
  });

// 获取上传图片凭证

export const getUploadSts = (params) =>
  request(`/v1/cos/refundSts`, "get", {
    params,
  });

// 获取文件列表
export const getFileList = (params) =>
  request(`/v1/course/file/list`, "get", {
    params,
  });
// 下载课程文件sts
export const getFileSts = (params) =>
  request(`/v1/userCourse/downloadCourseFileSts`, "get", {
    params,
  });
// 检查用户是否可以观看
export const checkLesson = (params) =>
  request(`/v1/userCourse/checkLesson`, "get", {
    params,
  });

// 图文课不复用视频课的详情和 KeepAlive 协议：它只有显式读取确认与
// 手动完成两个动作，避免被播放器统计为视频学习时长。
export const getRichMediaLesson = (params) =>
  request(`/v1/userCourse/rich-media-lesson/get`, "get", { params });

export const completeRichMediaLesson = (params) =>
  request(`/v1/userCourse/rich-media-lesson/complete`, "post", { json: params });

export const acknowledgeRichMediaContentUpdate = (params) =>
  request(`/v1/userCourse/rich-media-lesson/ack-content-update`, "post", { json: params });

// 新-订单列表
export const getOrdersList = (params) =>
  request(`/v1/order/getList`, "get", {
    params,
  });

// 取消订单
export const cancelOrder = (params) =>
  request(`/v1/order/cancel`, "get", {
    params,
  });

// 保存订单收货地址
export const saveOrderAddress = (params) =>
  request(`/v1/order/saveAddr`, "post", {
    json: params,
  });
